import axios from 'axios';
import { store } from 'store';
import { isAuthenticationError } from 'v2/utils/handleError';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BACKEND,
});

axiosInstance.interceptors.request.use(
  function (config) {
    const { user } = store.getState();
    if (user?.ghostUserEmail) {
      if (config.method !== 'get') {
        throw new Error('Edit data for ghosted users is not allowed');
      }
      config.headers['Ghost-User'] = user.ghostUserEmail;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (isAuthenticationError(error)) {
      if (window.location.href !== '/logout') {
        window.location.href = '/logout';
      }
    } else if (error.response?.data?.data?.key === 'ACCOUNT_DEACTIVATED') {
      // Timeout to show error and then redirect
      setTimeout(() => {
        if (window.location.pathname !== '/inactive') {
          window.location.href = '/inactive';
        }
      }, 2000);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
